module.exports = __webpack_public_path__ + "img/pos_tag_10.9f002ba5.png";